import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

@Component({
  selector: 'app-cadastrar-grupo-dados-gerais',
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatGridListModule,
    MatSelectModule,
    MatButtonModule,
    NgxMaskDirective,
    NgxMaskPipe
  ],
  providers: [provideNgxMask()],
  templateUrl: './cadastrar-grupo-dados-gerais.html',
  styleUrl: './cadastrar-grupo-dados-gerais.scss'
})
export class CadastrarGrupoDadosGerais {
  @Input() formData: any;
  @Input() readOnly: boolean = false;
  @Output() formDataChange = new EventEmitter<any>();
  @Output() salvar = new EventEmitter<void>();

  ufOptions: { id_uf: number; sigla: string; nome: string }[] = [];
  cidadeOptions: { id_cidade: number; id_uf: number; nome: string }[] = [];

  updateForm(field: string, value: any): void {
    this.formData[field] = value;
    this.formDataChange.emit(this.formData);
  }

  onSalvar(): void {
    this.salvar.emit();
  }
}
